import { getRequestCommonParameters } from '@lib/core/service/requests/api';

export const experiencesApiUrlCreator = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();
  return `/${retailerSlug}/${retailerLocationSlug}/experiences/`;
};
